module.exports = __webpack_public_path__ + "img/04.148535fc.png";